// import React, { useEffect, useState } from "react";
// import Select from "react-select";
// import axios from "axios";
// import { handleReportSubmitCard, submitReportCard } from "../reportUtils";
// import { teams } from "../CreateCardForm/teamslist";
// import { ToggleButton } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// import translations from "../../utils/language/translations.json";
// import '../../styles/components/reportModal.scss'
// const ReportFromFullPageListing = ({ onSubmit, userId, Data,liveCsrfToken,context }) => {
//   const card = Data;
//   console.log('card',card)
//   const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
//   const currentLang = i18n.language; // Access the current language
//   const t = (key) => translations.ReportModalFullPageListing[key][currentLang];
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [useAccountEmail, setUseAccountEmail] = useState(true);
//   const [isWrongData, setIsWrongData] = useState("This is wrong");
//   const [isWrongID,setIsWrongID] = useState(0);
//   const [isRightData,setIsRightData]=useState("This is right")
//   const [isRightID,setIsRightID]=useState(0)
//   const [selectOptions, setSelectOptions] = useState([]);

//   const [numberInput, setNumberInput] = useState(card?.numbered);

 
//   const [userEmail, setUserEmail] = useState("");
//   const initialFormData = {
//     selectedPage: "",
//     descriptionOptions: "",
//     adminResponse: "",
//     additionalComments: "",
//     IsRookie: card?.IsRookie === "Rookie(RC)",
//     IsAuto: card?.IsAuto !== "NotAuto",
//     IsPatch: card?.IsPatch !== "NotPatch",
//     IsJersey: card?.IsJersey !== "NotJersey",
//   };

//   const [formData, setFormData] = useState(initialFormData);
//   console.log("card", card);
//   const reasonOptions = context === 'user'
//   ? ["Seller/User"]
//   : ["Wrong Description or attribut", "Wrong Picture", "Seller/User", "Suggestion"];
//   const optionsByReason = {
//     "Wrong Description or attribut": [
//       "Player",
//       "Set/Year",
//       "Uniform",
//       "Card#",
//       "CardName",
//       "Variation",
//       "Attribut(Rookie-Auto-Patch)",
//     ],
//     "Wrong Picture": [
//       "Wrong order",
//       "Front Picture",
//       "Back Picture",
//       "Awfully Bad Quality Picture",
//       "Fake/stolen Image",
//     ],
//     "Seller/User": [
//       "I feel suspicious about this user",
//       "I had a bad Interaction with this user",
//     ],
//     Suggestion: [
//       "My Collection",
//       "MarketPlace",
//       "Add Card",
//       "Profil",
//       "Search",
//       "Template Selling/Trading",
//       "Other",
//     ],
//   };

//   const fetchUserEmail = async () => {
//     try {
//       // Construct the URL with the userId as a query parameter
//       const url = `${process.env.REACT_APP_API_BASE}/api/profil/getEmail/${userId}`;
//       const res = await fetch(url, {
//         method: "GET", // Use the GET method
//         headers: {
//           "Content-Type": "application/json", // Set the content type to JSON if needed
//         },
//         credentials: 'include',
//       });
//       const json = await res.json();
//       setUserEmail([json["Email"]]); // Update the userCards state with fresh data
//       console.log("Email retrieved", [json["Email"]]);
//     } catch (error) {
//       console.log("Error fetching user Email:", error);
//     }
//   };

//   const fetchSuggestions = async (inputValue, typeT) => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE}/api/searchbar/custom/${typeT}?searchTerm=${inputValue}`
//         ,{
//         withCredentials: true, // ✅ sends cookies/session
//       });
//       const suggestions = mapResponseToOptions(response.data, typeT);
//       setSelectOptions(suggestions);
//     } catch (error) {
//       console.error("Error fetching suggestions:", error);
//     }
//   };

//   const mapResponseToOptions = (data, typeT) => {
//     return data.map((item) => {
//       switch (typeT) {
//         case "player":
//           return { value: item.PlayerId, label: item.Name };
//         case "set":
//           return { value: item.setId, label: item.SetName };
//         case "card":
//           return { value: item.IdCardVariation, label: item.cardName };
//         case "variation":
//           return { value: item.IDVariation, label: item.variationName };
//       }
//     });
//   };

//   useEffect(() => {
//     if(userId)
//     fetchUserEmail();
//   }, []);

//   // Function to handle opening the modal
//   const openModal = () => {
//     setIsModalOpen(true);
//   };

//   // Function to handle closing the modal
//   const closeModal = () => {
//     setIsModalOpen(false);
//   };
//   function FindTheTeamNameById(teamId) {
//     const team = teams[teamId];
//     return team ? team.name : "Unknown Team";
//   }
//   const handleDescriptionChange = (event) => {
//     // 'Name','Set/Year', 'Uniform','Card#','CardName','Variation','Attribut(Rookie-Auto-Patch)'
//     setSelectOptions([]);
//     const { name, value } = event.target;
//     let wrongData;
//     let wrongDataID
//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     switch (value) {
//       case "Player":
//         wrongData = card.Name;
//         wrongDataID = card.PlayerId
//         break;
//       case "Set/Year":
//         wrongData = card.SetName;
//         wrongDataID = parseInt(card.Sets) // Assuming setName includes Set/Year data
//         break;
//       case "Uniform":
//         wrongData = FindTheTeamNameById(card.TeamsId);
//         wrongDataID = parseInt(card.TeamsId) // Assuming card has a Uniform property
//         break;
//       case "Card#":
//         wrongData = card.NumberBehind;
//         wrongDataID = 0 // Assuming card has a CardNumber property
//         break;
//       case "CardName":
//         wrongData = card.cardName;
//         wrongDataID = parseInt(card.IdCardVariation) // Assuming card has a CardName property
//         break;
//       case "Variation":
//         wrongData = card.variationName;
//         wrongDataID = parseInt(card.IDVariation) // Assuming card has a Variation property
//         break;
//       case "Attribut(Rookie-Auto-Patch)":
//         // Assuming card has properties to indicate if it is Rookie, Auto, and Patch
//         // This will concatenate those attributes with a dash in between
//         wrongDataID=card.IDVariation
//         wrongData = [
//           card.IsRookie === "Rookie(RC)" ? "Rookie" : "",
//           card.IsAuto === "NotAuto" ? "" : "Auto",
//           card.IsPatch === "NotPatch" ? "" : "Patch",
//           card.IsJersey === "NotJersey" ? "" : "Jersey",
//           card.numbered > 0 ? "/" + card.numbered : "",
//         ]
//           .filter(Boolean)
//           .join(" - ");
//         break;

//       default:
//         wrongData = "Unknown Value";
//     }

//     setIsWrongData(wrongData);
//     setIsWrongID(wrongDataID);
//   };
//   // Function to handle form field changes
//   const handleInputChange = (event) => {
//     const { name, value } = event.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleInputChangeInSelect = (selectedType) => (inputValue) => {
//     console.log(`Input Changed for ${selectedType}:`, inputValue);
//     if (inputValue.length >= 3) {
//       fetchSuggestions(inputValue, selectedType);
//     }
//   };

//   const handleSelect = (selectedType) => (selectedOption) => {
//     if (selectedOption) {
//       console.log(`Selected ${selectedType}:`, selectedOption.value);
//       // Additional logic based on selection
//       setIsRightData(selectedOption.label)
//       setIsRightID(selectedOption.value)
//     }
//   };

//   const ToggleButton = ({ label, name, value, onChange, disabled }) => {
//     const handleClick = () => {
//       if (!disabled) {
//         onChange(name, !value);
//       }
//     };

//     return (
//       <button
//         type="button"
//         className={`toggle-button ${value ? "active" : ""} ${
//           disabled ? "disabled" : ""
//         }`}
//         onClick={()=>handleClick}
//         disabled={disabled} // This will apply the native HTML disabled attribute
//         aria-pressed={value}
//       >
//         {label}
//       </button>
//     );
//   };

//   // Handle input changes
// const handleNumberInputChange = (event) => {
//   // Remove the initial "/" if present and update the state
//   const inputValue = event.target.value.startsWith('/') ? event.target.value.slice(1) : event.target.value;
//   setNumberInput(inputValue);
// };

//  // For ToggleButton, assume we are directly manipulating the formData state
// const handleToggleAttribute = (attribute) => {
//   setFormData((prevData) => ({
//     ...prevData,
//     [attribute]: !prevData[attribute],
//   }));
// };
 
//   // Render the correct input/select based on the selected description option
//   const renderCorrectInput = () => {
//     switch (formData.descriptionOptions) {
//       case "Player":
//         return (
//           <>
//             {/* <label>player:</label> */}
//             <Select
//               style={{ width: "auto" }}
//               className="custom-select"
//               options={selectOptions}
//               placeholder={t('Search for a player')}
//               isClearable
//               onChange={handleSelect("player")}
//               onInputChange={handleInputChangeInSelect("player")}
//               filterOption={() => true}
//             >
//               {/* Map over players from your database to create options */}
//             </Select>
//           </>
//         );
//       case "Set/Year":
//         return (
//           <>
//             {/* <label>player:</label> */}
//             <Select
//               style={{ width: "auto" }}
//               className="custom-select"
//               options={selectOptions}
//               placeholder={t('Search for a set')}
//               isClearable
//               onChange={handleSelect("set")}
//               onInputChange={handleInputChangeInSelect("set")}
//               filterOption={() => true}
//             >
//               {/* Map over players from your database to create options */}
//             </Select>
//           </>
//         );
//       case "Uniform":
//         const teamOptions = Object.values(teams)
//           .map((team) => ({
//             value: team.id,
//             label: `${team.name} (${team.abbreviation})`,
//           }))
//           .sort((a, b) => a.label.localeCompare(b.label)); // Sorting alphabetically by label
//         return (
//           <div>
//             <label>{t('Uniform')}:</label>
//             <Select
//               className="custom-select"
//               options={teamOptions}
//               onChange={()=>handleSelect("Uniform")}
//             />
//           </div>
//         );
//       case "Card#":
//         return (
//           <div>
//             <label>{t('Card')} #:</label>
//             <input type="text" placeholder={t('Enter Card Number')} />
//           </div>
//         );
//       case "CardName":
//         return (
//           <>
//             {/* <label>player:</label> */}
//             <Select
//               style={{ width: "auto" }}
//               className="custom-select"
//               options={selectOptions}
//               placeholder={t('Search for a cardName')}
//               isClearable
//               onChange={handleSelect("card")}
//               onInputChange={handleInputChangeInSelect("card")}
//               filterOption={() => true}
//             >
//               {/* Map over players from your database to create options */}
//             </Select>
//           </>
//         );
//       case "Variation":
//         return (
//           <>
//             {/* <label>player:</label> */}
//             <Select
//               style={{ width: "auto" }}
//               className="custom-select"
//               options={selectOptions}
//               placeholder={t('Search for a variation')}
//               isClearable
//               onChange={handleSelect("variation")}
//               onInputChange={handleInputChangeInSelect("variation")}
//               filterOption={() => true}
//             >
//               {/* Map over players from your database to create options */}
//             </Select>
//           </>
//         );
//       case "Attribut(Rookie-Auto-Patch)":
//         return (
//           <div>
//             <label>{t('Attributes')}:</label>
//             <div className="flex-h">
//             <ToggleButton
//           label={t('Rookie (RC)')}
//           name="IsRookie"
//           value={formData.IsRookie}
//           onChange={() => handleToggleAttribute("IsRookie")}
//         />
//                <ToggleButton
//           label="Patch"
//           name="IsPatch"
//           value={formData.IsPatch}
//           onChange={() => handleToggleAttribute("IsPatch")}
//         />

// <ToggleButton
//           label="Jersey"
//           name="IsJersey"
//           value={formData.IsJersey}
//           onChange={() => handleToggleAttribute("IsJersey")}
//         />
               
// <ToggleButton
//           label="Auto"
//           name="IsAuto"
//           value={formData.IsAuto}
//           onChange={() => handleToggleAttribute("IsAuto")}
//         />

               
// <ToggleButton
//           label="Tribute"
//           name="IsTribute"
//           value={formData.IsTribute}
//           onChange={() => handleToggleAttribute("IsTribute")}
//         />

//               {/* Display input for numbered if applicable */}
//               {card.numbered > 0 && (
//       <input
//         type="text"
//         value={`/${numberInput}`}
//         onChange={handleNumberInputChange}
//         placeholder={`/${card.numbered}`}
//       />
//     )}
//             </div>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   const constructRightData = () => {
//     let attributesArray = [];
//     if (formData.IsRookie) attributesArray.push("Rookie");
//     if (formData.IsAuto) attributesArray.push("Auto");
//     if (formData.IsPatch) attributesArray.push("Patch");
//     if (formData.IsJersey) attributesArray.push("Jersey");
//     if (numberInput) attributesArray.push(`/${numberInput}`);
  
//     return attributesArray.join(" - ");
//   };
//   // Function to handle submitting the form
//   const handleFormSubmit = async () => {
//     let thisIsFinalRight = isRightData
//     if(formData.descriptionOptions==='Attribut(Rookie-Auto-Patch)')
//     { thisIsFinalRight= constructRightData()}
//     const formDataWithUserEmail = {
//       ...formData,
//       userCardId:card.id,
//       userEmail: userEmail,
//       isWrongData:isWrongData,
//       isWrongID:isWrongID,
//       isRightData:thisIsFinalRight,
//       isRightID:isRightID,
//     };

//     console.log('formDataWithUserEmail',formDataWithUserEmail);
//     // Call the onSubmit callback with the form data

//     handleReportSubmitCard(userId, formDataWithUserEmail,liveCsrfToken,t);
//     // Close the modal after submission
//     setFormData(initialFormData);
//     closeModal();
//   };

//   return (
//     <div style={{marginLeft:'auto'}}>
//      <p className="issue"> <a  onClick={()=>openModal()}><span style={{}}>{t("Something wrong?")}</span> <span style={{color:'red'}}>{t("Let us know.")}</span></a></p>
//       {isModalOpen && (
//         <div className="modal-overlay">
//           <div  className="modal" style={{width:'fit-content'}}          >
   
//             <div className="report-issue-container">
      
//             <div className="flex-h" style={{paddingBottom:'0px',height:'fit-content'}}>       <button
//               className="modal-close"
//               onClick={closeModal}
//               style={{ fontSize: "14px",height:'fit-content'}}
//             >
//               {t('Close')}
//             </button><h2 style={{marginLeft:'20%',marginBottom:'0px'}}> {t('Report Issue')}</h2></div>
//             <form
//               // style={{
//               //   alignItems: "flex-start",
//               //   marginLeft: "30%",
//               //   width: "auto",
//               // }}
//             >
//               {/* Add your form fields here */}
//               <div className="form-group">

//     <label htmlFor="selectedPage">{t('Reason')}:</label>
//     <select
//       id="selectedPage"
//       name="selectedPage"
//       value={formData.selectedPage}
//       onChange={handleInputChange}
//       className="custom-select"
//     >
//       <option value="">{t('Select Page')}</option>
//       {reasonOptions.map((page) => (
//         <option key={page} value={page}>
//           {t(page)}
//         </option>
//       ))}
//     </select>
// </div>

// <div className="form-group">

//                 <label htmlFor="descriptionOptions">{t('Description')}:</label>
//                 <select
//                   id="descriptionOptions"
//                   name="descriptionOptions"
//                   value={formData.descriptionOptions}
//                   onChange={handleDescriptionChange}
//                   className="custom-select"
//                 >
//                   <option value="">{t('Select Description')}</option>
//                   {optionsByReason[formData.selectedPage]?.map((option) => (
//                     <option key={option} value={option}>
//                       {t(option)}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               {formData.selectedPage === "Wrong Description or attribut" && (
//                 <>
//                 <div className="form-group">
//                     <label>{t('Here is the wrong information')} :</label>
//                     <input disabled placeholder={isWrongData} />
//                   </div>
//                   <div>
//                     <label>{t('What is the correct information')}:</label>
//                     {renderCorrectInput()}
//                   </div>
//                 </>
//               )}

            
// <div className="form-group">
//                 <label htmlFor="adminResponse">{t('Admin Response')}:</label>
//                 <select
//                   id="adminResponse"
//                   name="adminResponse"
//                   value={formData.adminResponse}
//                   onChange={handleInputChange}
//                  className="custom-select"
//                 >
//                   <option value="Fix Only">{t('Only Fix the issue')}</option>
//                   <option value="Reply Needed">{t('Reply Needed')}</option>
//                 </select>
//               </div>

              
//               <div className="form-group">
//                 <label htmlFor="additionalComments">{t('Additional Comments')}:</label>
             
//                 <textarea
//                   type="text"
//                   id="additionalComments"
//                   name="additionalComments"
//                   value={formData.additionalComments}
//                   onChange={handleInputChange}
//                    rows={4}
//                   className="form-control"
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="userEmail">{t('Email')}:</label>
//                 <input
//                   type="email"
//                   id="userEmail"
//                   name="userEmail"
//                   value={userEmail}
//                   onChange={(e) => {
//                     if (!useAccountEmail) {
//                       setUserEmail(e.target.value);
//                     }
//                   }}
//                   disabled={useAccountEmail}
//                 />
//               </div>

//               <div className="form-group">
//                 <div className="flex-h">
//                 <label style={{marginBottom:'0px'}}>
//                   {t('Use my Account Email')}
//                 </label>
//                 <input style={{width:'fit-content',marginLeft:'10%'}}
//                     type="checkbox"
//                     checked={useAccountEmail}
//                     onChange={() => setUseAccountEmail((prev) => !prev)}
//                   />
//                   </div>
//               </div>
//               {/* Add more form fields as needed */}
//               <button
//                 type="button"
//                 className="submit-btn"
//                 onClick={handleFormSubmit}
//               >
//                 {t('Submit')}
//               </button>
//             </form>
//           </div>
//         </div></div>
//       )}
//     </div>
    
//   );
// };

// export default ReportFromFullPageListing;



import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { handleReportSubmitCard } from "../reportUtils";
import { teams } from "../CreateCardForm/teamslist";
import { useTranslation } from "react-i18next";
import translations from "../../utils/language/translations.json";
import "../../styles/components/reportModal.scss"; // keep your import for shared tokens
import ModalPortal from "../../utils/ModalPortal";
import { Modal } from "bootstrap";
const ReportFromFullPageListing = ({ userId, Data, liveCsrfToken, context }) => {
  const card = Data;
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const t = (k) => translations.ReportModalFullPageListing?.[k]?.[lang] ?? translations.ReportModal?.[k]?.[lang] ?? k;
  console.log('card Data?',card)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [useAccountEmail, setUseAccountEmail] = useState(true);
  const [accountEmail, setAccountEmail] = useState("");
  const [customEmail, setCustomEmail] = useState("");
  const emailValue = useAccountEmail ? accountEmail : customEmail;

  const [isWrongData, setIsWrongData] = useState("This is wrong");
  const [isWrongID, setIsWrongID] = useState(0);
  const [isRightData, setIsRightData] = useState("This is right");
  const [isRightID, setIsRightID] = useState(0);

  const [selectOptions, setSelectOptions] = useState([]);
  const [numberInput, setNumberInput] = useState(card?.numbered);
  const [submitting, setSubmitting] = useState(false);

  // form
  const initialForm = {
    reason: "",                 // (Select Page) -> renamed
    description: "",            // (Select Description)
    adminResponse: "Fix Only",
    additionalComments: "",
    IsRookie: card?.IsRookie === "Rookie(RC)",
    IsAuto:   card?.IsAuto   !== "NotAuto",
    IsPatch:  card?.IsPatch  !== "NotPatch",
    IsJersey: card?.IsJersey !== "NotJersey",
    IsTribute: false
  };
  const [form, setForm] = useState(initialForm);

  // ------- OPTIONS (translated labels, stable values) -------
  const reasonOptions = useMemo(() => {
    const base =
      context === "user"
        ? [{ value: "SellerUser", label: t("Seller/User") }]
        : [
            { value: "WrongDescription", label: t("Wrong Description or attribut") },
            { value: "WrongPicture",     label: t("Wrong Picture") },
            { value: "SellerUser",       label: t("Seller/User") },
            { value: "Suggestion",       label: t("Suggestion") },
          ];
    return base;
  }, [context, lang]); // lang to re-compute on language change

  const descriptionOptions = useMemo(() => {
    switch (form.reason) {
      case "WrongDescription":
        return [
          { value: "Player",  label: t("Player") },
          { value: "SetYear", label: t("Set/Year") },
          { value: "Uniform", label: t("Uniform") },
          { value: "CardNum", label: `${t("Card")} #` },
          { value: "CardName", label: t("CardName") },
          { value: "Variation", label: t("Variation") },
          { value: "Attr",      label: t("Attribut(Rookie-Auto-Patch)") },
        ];
      case "WrongPicture":
        return [
          { value: "Order",     label: t("Wrong order") },
          { value: "Front",     label: t("Front Picture") },
          { value: "Back",      label: t("Back Picture") },
          { value: "BadQual",   label: t("Awfully Bad Quality Picture") },
          { value: "Fake",      label: t("Fake/stolen Image") },
        ];
      case "SellerUser":
        return [
          { value: "Suspicious", label: t("I feel suspicious about this user") },
          { value: "BadInteract", label: t("I had a bad Interaction with this user") },
        ];
      case "Suggestion":
        return [
          { value: "MyCollection", label: t("My Collection") },
          { value: "MarketPlace",  label: t("MarketPlace") },
          { value: "AddCard",      label: t("Add Card") },
          { value: "Profil",       label: t("Profil") },
          { value: "Search",       label: t("Search") },
          { value: "Template",     label: t("Template Selling/Trading") },
          { value: "Other",        label: t("Other") },
        ];
      default:
        return [];
    }
  }, [form.reason, lang]);

  // ------- react-select dark theme (same as your other form) -------
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      background: "rgba(255,255,255,.06)",
      borderColor: state.isFocused ? "#0071E7" : "rgba(255,255,255,.14)",
      boxShadow: "none",
      minHeight: 40,
      borderRadius: 12,
      color: "#fff",
      ":hover": { borderColor: state.isFocused ? "#0071E7" : "rgba(255,255,255,.22)" },
    }),
    valueContainer: (base) => ({ ...base, padding: "0 .75rem" }),
    singleValue: (base) => ({ ...base, color: "#fff" }),
    placeholder: (base) => ({ ...base, color: "rgba(255,255,255,.65)" }),
    input: (base) => ({ ...base, color: "#fff" }),
    dropdownIndicator: (base) => ({ ...base, color: "rgba(255,255,255,.7)" }),
    indicatorSeparator: (base) => ({ ...base, background: "rgba(255,255,255,.12)" }),
    menu: (base) => ({
      ...base,
      background: "#151a22",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 12,
      boxShadow: "0 12px 28px rgba(0,0,0,.45)",
      overflow: "hidden",
      zIndex: 50,
    }),
    menuList: (base) => ({ ...base, padding: 0, maxHeight: 280 }),
    option: (base, state) => ({
      ...base,
      background: state.isSelected ? "#0a64e8" : state.isFocused ? "rgba(10,100,232,.15)" : "transparent",
      color: "#fff",
      cursor: "pointer",
      padding: "10px 12px",
      ":active": { background: "#0a64e8" },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  // ------- data helpers -------
  const FindTheTeamNameById = (id) => (teams[id]?.name ?? "Unknown Team");

  // fetch account email
useEffect(() => {
  if (!userId) return;
  (async () => {
    try {
      const url = `${process.env.REACT_APP_API_BASE}/api/profil/getEmail/${encodeURIComponent(userId)}`;
      const res = await fetch(url, { method: "GET", credentials: "include" });

      if (!res.ok) {
        // Handle 404/500 gracefully
        console.warn('Email fetch failed:', res.status, res.statusText);
        setAccountEmail("");
        return;
      }

      const ct = res.headers.get("content-type") || "";
      if (!ct.includes("application/json")) {
        // Avoid json() on empty/HTML responses
        const text = await res.text();
        console.warn('Expected JSON, got:', text);
        setAccountEmail("");
        return;
      }

      const json = await res.json();
      setAccountEmail(json?.Email || "");
      console.log('apres le get', json);
    } catch (e) {
      console.error("Error fetching user email:", e);
      setAccountEmail("");
    }
  })();
}, [userId]);


  // remote search for select
  const fetchSuggestions = async (term, type) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/searchbar/custom/${type}?searchTerm=${term}`,
        { withCredentials: true }
      );
      const mapped = (res.data || []).map((item) => {
        switch (type) {
          case "player":    return { value: item.PlayerId,      label: item.Name };
          case "set":       return { value: item.setId,         label: item.SetName };
          case "card":      return { value: item.IdCardVariation, label: item.cardName };
          case "variation": return { value: item.IDVariation,   label: item.variationName };
          default:          return { value: "", label: "" };
        }
      });
      setSelectOptions(mapped);
    } catch (e) {
      console.error(e);
    }
  };

  // ------- handlers -------
  const openModal  = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const onChangeReason = (opt) => {
    setForm((p) => ({ ...p, reason: opt?.value || "", description: "" }));
    // reset wrong/right
    setSelectOptions([]);
    setIsWrongData("This is wrong");
    setIsWrongID(0);
    setIsRightData("This is right");
    setIsRightID(0);
  };

  const onChangeDescription = (opt) => {
    const value = opt?.value || "";
    setForm((p) => ({ ...p, description: value }));
    setSelectOptions([]);

    // prefill wrong data/id from current card
    switch (value) {
      case "Player":   setIsWrongData(card.Name);          setIsWrongID(card.PlayerId); break;
      case "SetYear":  setIsWrongData(card.SetName);       setIsWrongID(Number(card.Sets)); break;
      case "Uniform":  setIsWrongData(FindTheTeamNameById(card.TeamsId)); setIsWrongID(Number(card.TeamsId)); break;
      case "CardNum":  setIsWrongData(card.NumberBehind);  setIsWrongID(0); break;
      case "CardName": setIsWrongData(card.cardName);      setIsWrongID(Number(card.IdCardVariation)); break;
      case "Variation":setIsWrongData(card.variationName); setIsWrongID(Number(card.IDVariation)); break;
      case "Attr":
        setIsWrongID(card.IDVariation);
        setIsWrongData(
          [
            card.IsRookie === "Rookie(RC)" ? "Rookie" : "",
            card.IsAuto !== "NotAuto" ? "Auto" : "",
            card.IsPatch !== "NotPatch" ? "Patch" : "",
            card.IsJersey !== "NotJersey" ? "Jersey" : "",
            card.numbered > 0 ? `/${card.numbered}` : "",
          ].filter(Boolean).join(" - ")
        );
        break;
      default:
        setIsWrongData("");
        setIsWrongID(0);
    }
  };

  const onChangeAdmin = (opt) => setForm((p) => ({ ...p, adminResponse: opt?.value || "Fix Only" }));
  const onChangeComments = (e) => setForm((p) => ({ ...p, additionalComments: e.target.value }));

  const handleNumberInputChange = (e) => {
    const v = e.target.value.startsWith("/") ? e.target.value.slice(1) : e.target.value;
    setNumberInput(v);
  };

  const handleAttributeToggle = (key) => {
    setForm((p) => ({ ...p, [key]: !p[key] }));
  };

  // build "right" data for attributes block
  const buildRightAttr = () => {
    const arr = [];
    if (form.IsRookie) arr.push("Rookie");
    if (form.IsAuto)   arr.push("Auto");
    if (form.IsPatch)  arr.push("Patch");
    if (form.IsJersey) arr.push("Jersey");
    if (numberInput)   arr.push(`/${numberInput}`);
    return arr.join(" - ");
  };

  const onRemoteInput = (type) => (input) => {
    if ((input || "").length >= 3) fetchSuggestions(input, type);
  };

  const onRemoteSelect = (type) => (opt) => {
    if (!opt) return;
    setIsRightData(opt.label);
    setIsRightID(opt.value);
  };

  const canSubmit =
    !!form.reason &&
    !!form.description &&
    (!!emailValue && /.+@.+\..+/.test(emailValue));

  const onSubmit = async () => {
    if (!canSubmit || submitting) return;
    setSubmitting(true);
    try {
      let finalRight = isRightData;
      if (form.description === "Attr") finalRight = buildRightAttr();

      const payload = {
        reason: form.reason,
        description: form.description,
        adminResponse: form.adminResponse,
        additionalComments: form.additionalComments,
        userCardId: card.id,
        userEmail: emailValue,
        isWrongData,
        isWrongID,
        isRightData: finalRight,
        isRightID,
      };

      await handleReportSubmitCard(userId, payload, liveCsrfToken, t);
      setForm(initialForm);
      setIsRightData("This is right");
      setIsRightID(0);
      setIsWrongData("This is wrong");
      setIsWrongID(0);
      setNumberInput(card?.numbered);
      closeModal();
    } catch (e) {
      console.error(e);
    } finally {
      setSubmitting(false);
    }
  };

  // ------- admin response options -------
  const adminOptions = [
    { value: "Fix Only",     label: t("Only Fix the issue") },
    { value: "Reply Needed", label: t("Reply Needed") },
  ];

  // ------- TEAM options if user chooses Uniform -------
  const teamOptions = useMemo(() => {
    return Object.values(teams)
      .map((tm) => ({ value: tm.id, label: `${tm.name} (${tm.abbreviation})` }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, []);

  return (
    <div style={{ marginLeft: "auto" }}>
      <p className="issue">
        <a onClick={openModal}>
          <span>{t("Something wrong?")}</span> <span style={{ color: "red" }}>{t("Let us know.")}</span>
        </a>
      </p>

      {isModalOpen && (
        <ModalPortal>
        <div className="modal-overlay">
          <div className="modal" style={{maxWidth:'35rem',maxHeight:'fit-content'}} >
            <div className="report-issue-container">
                      
              <div className="flex-h" style={{ paddingBottom: 0 }}>
       <button className="btn-ghost" onClick={closeModal} style={{ fontSize: 14 }}>
                  {t("Close")}
                </button>
                <h2 className="report-title" style={{ marginBottom: 0 }}>{t("Report Issue")}</h2>
              </div>

              {/* Reason */}
              <div className="form-group">
                <label>{t("Reason")}</label>
                <Select
                  styles={selectStyles}
                  classNamePrefix="rs"
                  menuPortalTarget={document.body}
                  placeholder={t("Select Reason")}
                  value={reasonOptions.find((o) => o.value === form.reason) || null}
                  onChange={onChangeReason}
                  options={reasonOptions}
                />
              </div>

              {/* Description */}
              <div className="form-group">
                <label>{t("Description")}</label>
                <Select
                  styles={selectStyles}
                  classNamePrefix="rs"
                  menuPortalTarget={document.body}
                  placeholder={t("Select Description")}
                  value={descriptionOptions.find((o) => o.value === form.description) || null}
                  onChange={onChangeDescription}
                  options={descriptionOptions}
                  isDisabled={!form.reason}
                />
              </div>

              {/* Wrong + Right data section for WrongDescription */}
              {form.reason === "WrongDescription" && (
                <>
                  <div className="form-group">
                    <label>{t("Here is the wrong information")}:</label>
                    <input className="input" disabled value={isWrongData} />
                  </div>

                  <div className="form-group">
                    <label>{t("What is the correct information")}:</label>

                    {form.description === "Player" && (
                      <Select
                        styles={selectStyles}
                        classNamePrefix="rs"
                        menuPortalTarget={document.body}
                        placeholder={t("Search for a player")}
                        options={selectOptions}
                        onInputChange={onRemoteInput("player")}
                        onChange={onRemoteSelect("player")}
                        isClearable
                        filterOption={() => true}
                      />
                    )}

                    {form.description === "SetYear" && (
                      <Select
                        styles={selectStyles}
                        classNamePrefix="rs"
                        menuPortalTarget={document.body}
                        placeholder={t("Search for a set")}
                        options={selectOptions}
                        onInputChange={onRemoteInput("set")}
                        onChange={onRemoteSelect("set")}
                        isClearable
                        filterOption={() => true}
                      />
                    )}

                    {form.description === "Uniform" && (
                      <Select
                        styles={selectStyles}
                        classNamePrefix="rs"
                        menuPortalTarget={document.body}
                        placeholder={t("Uniform")}
                        options={teamOptions}
                        onChange={(opt) => { if (opt) { setIsRightData(opt.label); setIsRightID(opt.value); } }}
                        isClearable
                      />
                    )}

                    {form.description === "CardNum" && (
                      <input
                        className="input"
                        type="text"
                        placeholder={t("Enter Card Number")}
                        value={`/${numberInput || ""}`}
                        onChange={handleNumberInputChange}
                      />
                    )}

                    {form.description === "CardName" && (
                      <Select
                        styles={selectStyles}
                        classNamePrefix="rs"
                        menuPortalTarget={document.body}
                        placeholder={t("Search for a cardName")}
                        options={selectOptions}
                        onInputChange={onRemoteInput("card")}
                        onChange={onRemoteSelect("card")}
                        isClearable
                        filterOption={() => true}
                      />
                    )}

                    {form.description === "Variation" && (
                      <Select
                        styles={selectStyles}
                        classNamePrefix="rs"
                        menuPortalTarget={document.body}
                        placeholder={t("Search for a variation")}
                        options={selectOptions}
                        onInputChange={onRemoteInput("variation")}
                        onChange={onRemoteSelect("variation")}
                        isClearable
                        filterOption={() => true}
                      />
                    )}

                    {form.description === "Attr" && (
                      <div className="field">
                        <div className="toggle-button-group">
                          <button
                            type="button"
                            className={`toggle-button ${form.IsRookie ? "active" : ""}`}
                            onClick={() => handleAttributeToggle("IsRookie")}
                          >
                            {t("Rookie (RC)")}
                          </button>
                          <button
                            type="button"
                            className={`toggle-button ${form.IsAuto ? "active" : ""}`}
                            onClick={() => handleAttributeToggle("IsAuto")}
                          >
                            Auto
                          </button>
                          <button
                            type="button"
                            className={`toggle-button ${form.IsPatch ? "active" : ""}`}
                            onClick={() => handleAttributeToggle("IsPatch")}
                          >
                            Patch
                          </button>
                          <button
                            type="button"
                            className={`toggle-button ${form.IsJersey ? "active" : ""}`}
                            onClick={() => handleAttributeToggle("IsJersey")}
                          >
                            Jersey
                          </button>
                          <button
                            type="button"
                            className={`toggle-button ${form.IsTribute ? "active" : ""}`}
                            onClick={() => handleAttributeToggle("IsTribute")}
                          >
                            Tribute
                          </button>
                        </div>

                        {card.numbered > 0 && (
                          <input
                            className="input"
                            type="text"
                            value={`/${numberInput || ""}`}
                            onChange={handleNumberInputChange}
                            placeholder={`/${card.numbered}`}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* Admin response */}
              <div className="form-group">
                <label>{t("Admin Response")}</label>
                <Select
                  styles={selectStyles}
                  classNamePrefix="rs"
                  menuPortalTarget={document.body}
                  placeholder={t("Select Response")}
                  value={adminOptions.find((o) => o.value === form.adminResponse) || null}
                  onChange={onChangeAdmin}
                  options={adminOptions}
                />
              </div>

              {/* Comments */}
              <div className="form-group">
                <label>{t("Additional Comments")}</label>
                <textarea
                  className="custom-textarea"
                  rows={3}
                  value={form.additionalComments}
                  onChange={onChangeComments}
                />
              </div>

              {/* Email row */}
              <div className="email-checkbox-container">
                <div className="checkbox-container">
                  <label htmlFor="useAccountEmail" style={{ marginBottom: 0 }}>
                    <input
                      id="useAccountEmail"
                      type="checkbox"
                      checked={useAccountEmail}
                      style={{ marginRight: "10px",maxWidth:'fit-content' }}
                      onChange={() => setUseAccountEmail((p) => !p)}
                    />
                    {t("Use my Account Email")}
                  </label>
                </div>

                <input
                  type="email"
                  className="email-input"
                  placeholder={t("Email")}
                  value={emailValue}
                  disabled={useAccountEmail}
                  onChange={(e) => setCustomEmail(e.target.value)}
                />
              </div>

              {/* Submit */}



              <button
                type="button"
                onClick={onSubmit}
                className={`submit-btn ${submitting ? "is-loading" : ""}`}
                disabled={!canSubmit || submitting}
                aria-busy={submitting}
                aria-live="polite"
              >
                {submitting ? (
                  <>
                    <span className="spinner" aria-hidden="true" />
                    {t("Submit")}…
                  </>
                ) : (
                  t("Submit")
                )}
              </button>
            </div>
          </div>
        </div></ModalPortal>
      )}
    </div>
  );
};

export default ReportFromFullPageListing;
